import { randomstring } from "randomstring-js";
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
  uploadEncodedFile,
} from "NetworkCall";
import _ from "lodash";
import { INSTANCE_URL, BASE_IMAGES_URL, itemCount } from "Constants";

export var COMMUNITY_LIST = "COMMUNITY_LIST";
export var OPEN_COMMUNITY_MODAL = "OPEN_COMMUNITY_MODAL";
export var LOAD_EDIT_COMMUNITY_DATA = "LOAD_EDIT_COMMUNITY_DATA";
export var COMMUNITY_REQUESTED_USERS_LIST = "COMMUNITY_REQUESTED_USERS_LIST";

export function fetchCommunity(session, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;
  var filter = encodeURI(`eventid=${session.eventid}`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/communitycategory?include_count=true&related=communitymember_by_communitycategoryidfk&filter=(${filter})&order=createdon%20DESC${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: COMMUNITY_LIST,
          payload: { data: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function searchCommunity(session, search = "", pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;
  var searchQuery = `(categoryname like %${search}%) OR (type like %${search}%)`;
  var filter = encodeURI(`(${searchQuery}) AND (eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/communitycategory?include_count=true&related=communitymember_by_communitycategoryidfk&filter=(${filter})&order=createdon%20DESC${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: COMMUNITY_LIST,
          payload: { data: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function communityModal(obj) {
  return {
    type: OPEN_COMMUNITY_MODAL,
    payload: obj,
  };
}

export function saveCommunity(
  session,
  values,
  community,
  globalSelectedUsers,
  callback
) {
  var eventid = session.eventid;
  values = { ...values, eventid };
  var imagedata = values.categoryicon ? values.categoryicon : "";

  if (imagedata.search(";base64,") > 0) {
    imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, "");
    var filename = `eventify/${eventid}/images/community/${randomstring(
      32
    )}.jpg`;
    var imageJson = {
      resource: [
        {
          name: filename,
          type: "file",
          is_base64: true,
          content: imagedata,
        },
      ],
    };

    return (dispatch) => {
      uploadEncodedFile(
        `${BASE_IMAGES_URL}?check_exist=false`,
        session,
        imageJson,
        dispatch,
        (data) => {
          //debugger;
          values = { ...values, categoryicon: data.path };
          // image is uploaded and filepath is appended
          // create / update community
          dispatch(
            _createUpdateCommunity(
              session,
              values,
              community,
              globalSelectedUsers,
              callback
            )
          );
        },
        (error) => {
          callback({ error: 2, data: error });
        }
      );
    };
  } else {
    return (dispatch) => {
      // if (newsitem && newsitem.newsimage) {
      //   values = {
      //     ...values,
      //     newsimage: newsitem.newsimage,
      //     newsthumbimage: newsitem.newsthumbimage,
      //   };
      // } else {
      //   values = { ...values, newsimage: "", newsthumbimage: "" };
      // }
      dispatch(
        _createUpdateCommunity(
          session,
          values,
          community,
          globalSelectedUsers,
          callback
        )
      );
    };
  }
}

function _createUpdateCommunity(
  session,
  values,
  community,
  globalSelectedUsers,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/communitycategory/`;

  return (dispatch) => {
    var successCallback = (data) => {
      callback({ error: 0, data: data });
    };

    var errorCallback = (error) => {
      callback({ error: 1, data: error });
    };

    if (community.communitycategoryid) {
      patchRequest(
        url,
        { resource: values },
        session,
        dispatch,
        successCallback,
        errorCallback
      );
    } else {
      /* Create an array of objects if Community Category Is Private */
      let arr = [];
      if (!_.isEmpty(globalSelectedUsers)) {
        _.forEach(globalSelectedUsers, (item, index) => {
          let obj = {
            eventid: parseInt(session.eventid),
            useridfk: item.appuserid,
            status: "accepted",
          };
          arr.push(obj);
        });

        // Insert Created arrayinto values
        values["communitymember_by_communitycategoryidfk"] = arr;
      }

      postRequest(
        url,
        { resource: values },
        session,
        dispatch,
        successCallback,
        errorCallback
      );
    }
  };
}

export function editCommunity(data) {
  return {
    type: LOAD_EDIT_COMMUNITY_DATA,
    payload: data,
  };
}

export function deleteCommunity(session, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/communitycategory/${id}`;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0, data: data });
      },
      (error) => {
        callback({ error: 1, error: error });
      }
    );
  };
}

/* Requested Users list [Community memeber]*/
export function fetchRequestedUsers(session, callback) {
  let filter = encodeURI(`(eventid=${session.eventid})AND(status="requested")`);

  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitymember?include_count=true&related=appuser_by_useridfk&filter=(${filter})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: COMMUNITY_REQUESTED_USERS_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}
